'use client'

import { useMemo } from 'react'

import { Icon, IconComponent } from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { getNavigationItems } from '@common/config/navigation'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

export function AppPickerDrawer() {
  const { appVariant, isAppPickerOpen, setIsAppPickerOpen } = useMobileMenuContext()
  const navigationItems = useMemo(() => getNavigationItems(appVariant), [appVariant])

  const handleClose = () => setIsAppPickerOpen(false)

  const handleAppClick = (appId: string, url: string, disabled?: boolean) => {
    if (disabled) return
    handleClose()
    if (url) {
      // eslint-disable-next-line react-hooks/immutability -- full-page app switch via navigation config URL
      window.location.href = url
    }
  }

  return (
    <Dialog.Root open={isAppPickerOpen} onOpenChange={(open) => !open && handleClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.appPickerOverlay} />
        <Dialog.Content className={styles.appPickerDrawer} data-testid={MOBILE_MENU_TEST_IDS.appPickerDrawer}>
          <div className={styles.appPickerHeader}>
            <div className={styles.appPickerDragHandle} />
            <Dialog.Title className={styles.appPickerTitle}>Select app</Dialog.Title>
            <div className={styles.appPickerDivider} />
          </div>

          <div className={styles.appPickerContent}>
            {navigationItems.map((item) => {
              const isSelected = item.id === appVariant
              const isDisabled = item.disabled

              return (
                <button
                  key={item.id}
                  className={`${styles.appPickerItem} ${isSelected ? styles.selected : ''} ${isDisabled ? styles.disabled : ''}`}
                  onClick={() => handleAppClick(item.id, item.url, isDisabled)}
                  disabled={isDisabled}
                >
                  <IconComponent icon={item.icon} size={20} className={styles.appPickerItemIcon} />
                  <span className={styles.appPickerItemLabel}>{item.label}</span>
                  {isSelected ? (
                    <IconComponent icon={Icon.CheckmarkRegular} size={24} className={styles.appPickerCheckmark} />
                  ) : null}
                </button>
              )
            })}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
